import { useRouter } from 'next/router';

import { campaginDateRange } from '~/domains/campaign/helper';
import { useHomeCampaignList } from '~/domains/campaign/queries';

import { CampaignHorizontalProductListTypeSection } from './CampaignHorizontalProductListTypeSection';
import { CampaignNotFound } from './CampaignNotFound';
import { HomeCampaignEventTypeSection } from './HomeCampaignEventTypeSection';

export function HomeCampaignList() {
  const { query } = useRouter();
  const { data } = useHomeCampaignList();
  const isToday =
    query.campaignDate === campaginDateRange.TODAY || !query.campaignDate;

  if (!data || data.length === 0) {
    return <CampaignNotFound />;
  }

  return (
    <div className="flex flex-col gap-16">
      {data?.map((campaign) => {
        if (campaign.type === 'EVENT') {
          return (
            <HomeCampaignEventTypeSection
              campaign={campaign}
              key={campaign.campaignId}
              isToday={isToday}
            />
          );
        }

        if (campaign.type === 'PRODUCT' && !!campaign.products?.length) {
          return (
            <CampaignHorizontalProductListTypeSection
              campaign={campaign}
              key={campaign.campaignId}
              isToday={isToday}
            />
          );
        }

        return null;
      })}
    </div>
  );
}
